<script>
export default {
  props: {
    defaultText: {
      type: String,
      default: "Text",
    },
  },
};
</script>

<template>
  <span class="span">{{ defaultText }}</span>
</template>
